import React from 'react';
import FooterMenu from './FooterMenu';
import FooterLogo from '../../Elements/Icon/assets/footer-logo.component.svg';
import clsx from 'clsx';

import Row from '../Layout/Row';
import Wrapper from '../Layout/Wrapper';


const Footer = ({ withFooterMenu = true }) => {
    return (
        <>
            <Row>
                <Wrapper>
                    <div className={clsx("footer", { 'footer--with-menu': withFooterMenu })}>
                        <FooterLogo />
                    </div>
                </Wrapper>  
            </Row>
            { withFooterMenu ? <FooterMenu /> : null }
        </>
    );
}

export default Footer;